import { render, staticRenderFns } from "./CurrentVersion.vue?vue&type=template&id=03d0b43e&"
import script from "./CurrentVersion.vue?vue&type=script&lang=js&"
export * from "./CurrentVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports